import type { Client } from '../../../../redux/reducers/clients'

const DEFAULT_MAP_HREF =
  'https://yandex.ru/maps/?text=%D0%9C%D0%BE%D1%81%D0%BA%D0%B2%D0%B0%2C%20%D1%83%D0%BB.%20%D0%9D%D0%B0%D0%B1%D0%B5%D1%80%D0%B5%D0%B6%D0%BD%D0%B0%D1%8F%2C%2034'

export function buildYandexMapsHrefFromClient(
  client: Client | null | undefined
): string {
  if (!client) return DEFAULT_MAP_HREF
  const parts = [client.city?.name, client.district, client.address].filter(
    (p) => typeof p === 'string' && p.trim().length > 0
  )
  if (!parts.length) return DEFAULT_MAP_HREF
  return `https://yandex.ru/maps/?text=${encodeURIComponent(parts.join(', '))}`
}

export { DEFAULT_MAP_HREF }
